import withCompController from '../../StylableButton/viewer/StylableButton.controller';

export default withCompController;
